import { logOpenSmartSnippetInlineLink, logOpenSmartSnippetSource, logOpenSmartSnippetSuggestionInlineLink, logOpenSmartSnippetSuggestionSource, } from '../question-answering/question-answering-analytics-actions.js';
import { logDocumentOpen } from '../result/result-analytics-actions.js';
/**
 * Returns possible click analytics action creators.
 *
 * @param engine - The headless engine.
 * @returns An object holding the action creators.
 *
 * @group Actions
 * @category Analytics
 */
export function loadClickAnalyticsActions(engine) {
    engine.addReducers({});
    return {
        logDocumentOpen,
        logOpenSmartSnippetSource,
        logOpenSmartSnippetSuggestionSource,
        logOpenSmartSnippetInlineLink,
        logOpenSmartSnippetSuggestionInlineLink,
    };
}
